export enum ConnectorUiState {
  Available = 'available',
  Booked = 'booked',
  InUse = 'in-use',
  Unavailable = 'unavailable',
}
